import { render, staticRenderFns } from "./DetalleFacturas.vue?vue&type=template&id=26459294&"
import script from "./DetalleFacturas.vue?vue&type=script&lang=js&"
export * from "./DetalleFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports